var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogov2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 29,
    viewBox: "0 0 86 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51775 3.73714C9.36061 3.73714 9.23251 3.86252 9.23251 4.0182V7.18736V7.84543C9.23251 8.00027 9.35976 8.12649 9.51775 8.12649H13.2472C13.4043 8.12649 13.5324 8.25188 13.5324 8.40756V12.0825C13.5324 12.2373 13.6597 12.3635 13.8177 12.3635H14.4855H17.7017C17.8588 12.3635 17.9869 12.2381 17.9869 12.0825V4.01904C17.9869 3.86421 17.8597 3.73798 17.7017 3.73798H9.51861L9.51775 3.73714Z",
    fill: "#CFD6FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9861 17.5363V16.8783C17.9861 16.7234 17.8588 16.5972 17.7008 16.5972H5.21783C5.06069 16.5972 4.93259 16.4718 4.93259 16.3161V4.01651C4.93259 3.86167 4.80534 3.73544 4.64735 3.73544H0.764181C0.607044 3.73544 0.478943 3.86083 0.478943 4.01651V20.7046C0.478943 20.8595 0.60619 20.9857 0.764181 20.9857H17.7C17.8571 20.9857 17.9852 20.8603 17.9852 20.7046V17.5355L17.9861 17.5363Z",
    fill: "#CFD6FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2638 28.1252V3.94499H27.4006V23.719H39.5591V28.1252H22.2638Z",
    fill: "#164CAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7958 28.1252V3.94499H59.8307V8.16941H46.7849V13.3405H58.7957V17.6011H46.7849V23.8284H60.4217V28.1252H41.7958Z",
    fill: "#164CAE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0153 16.2538C62.0153 8.05996 66.2648 3.14381 73.804 3.14381C81.3432 3.14381 85.5193 8.05996 85.5193 16.3632C85.5193 24.6665 81.3432 28.9633 73.804 28.9633C66.2648 28.9633 62.0153 24.4115 62.0153 16.2538ZM80.4567 16.3632C80.4567 10.6459 78.0911 7.62321 73.8049 7.62321C69.5186 7.62321 67.0787 10.6459 67.0787 16.3632C67.0787 22.0805 69.5545 24.6294 73.8049 24.6294C77.5001 24.6294 80.4567 22.0805 80.4567 16.3632Z",
    fill: "#164CAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogov2);
export default __webpack_public_path__ + "static/media/logov2.92116bf5fce9c86e273fca43bc00e264.svg";
export { ForwardRef as ReactComponent };